import { NewFactory, New, NewFactoryError, Title, NewDate, Content } from '@/Domain/News'
import { AxiosNewsData } from './AxiosNewsData'

export class AxiosNewFactory implements NewFactory<AxiosNewsData> {
  makeNew (data: AxiosNewsData): New {
    try {
      return new New(
        new Title(data.title === null ? '' : data.title),
        new NewDate(data.date.replace(/-/g, '/')),
        new Content(data.content)
      )
    } catch (error) {
      throw new NewFactoryError(error.message)
    }
  }
}
